module.exports = __webpack_public_path__ + "img/review.69c4a4d3.png";